import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';

import Skeleton from '@material-ui/lab/Skeleton';
//Material Imports
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import { Grid } from '@material-ui/core';

export default function LoadingSkeleton(props) {
  const bigCard = () => {
    return (
      <Card className="card timer-card">
        <CardContent className="card-header">
          <p className="card-title">
            <Skeleton variant="text" width={'20%'} />
            <Skeleton variant="text" width={'30%'} />
          </p>
          <p className="subject-title">
            <Skeleton variant="text" />
          </p>
        </CardContent>
        <div className="card-background">
          <Skeleton variant="rect" className="card-image" />
        </div>
        <CardActions className="card-action flex flex-space-between ml-10 mr-10">
          <Skeleton variant="circle" width={40} height={40} />
          <Skeleton variant="text" width={'20%'} />
          <Skeleton variant="text" width={'30%'} />
        </CardActions>
      </Card>
    );
  };

  const smallCard = () => {
    return (
      <Card className="card timer-card">
        <CardContent className="card-header">
          <p className="card-title">
            <Skeleton variant="text" width="80px" />
            <Skeleton variant="text" width="120px" />
          </p>
          <p className="subject-title">
            <Skeleton variant="text" width="120px" />
          </p>
        </CardContent>
        <CardActions className="card-action">
          <p>
            <span className="action-title">
              <Skeleton variant="text" width="120px" />
            </span>
          </p>
          <Skeleton variant="text" width="160px" height="40px" />
        </CardActions>
      </Card>
    );
  };
  const downloads = () => {
    return (
      <Card className="card timer-card">
        <CardContent className="card-header">
          <p className="card-title">
            <Skeleton variant="text" width="80px" />
            <Skeleton variant="text" width="120px" />
          </p>
          <p className="subject-title">
            <Skeleton variant="text" width="120px" />
          </p>
        </CardContent>
      </Card>
    );
  };

  const smallCardList = () => {
    return (
      <Card className="card timer-card">
        <CardContent className="card-header">
          <p className="card-title">
            <Skeleton variant="text" width="80px" />
            <Skeleton variant="text" width="120px" />
          </p>
          <p className="subject-title">
            <Skeleton variant="text" width="120px" />
          </p>
        </CardContent>
      </Card>
    );
  };

  const listItem = () => {
    return (
      <Grid container className="multiple-list">
        <Grid item xs>
          <div className="list-card-subjects border-none">
            <List
              subheader={
                <ListSubheader component="div" className="mt-20 mb-20">
                  <Skeleton variant="text" width={'20%'} height="20px" />
                </ListSubheader>
              }
            >
              <ListItem>
                <Skeleton width={'100%'} />
              </ListItem>
              <ListItem>
                <Skeleton width={'100%'} />
              </ListItem>
              <ListItem>
                <Skeleton width={'100%'} />
              </ListItem>
              <ListItem>
                <Skeleton width={'100%'} />
              </ListItem>
            </List>
          </div>
        </Grid>
      </Grid>
    );
  };

  const homeBatchlist = () => {
    return (
      <ul>
        <li className="mb-20">
          <Skeleton />
          <Skeleton width={'40%'} />
        </li>
        <li className="mb-20">
          <Skeleton />
          <Skeleton width={'40%'} />
        </li>
        <li className="mb-20">
          <Skeleton />
          <Skeleton width={'40%'} />
        </li>
        <li className="mb-20">
          <Skeleton />
          <Skeleton width={'40%'} />
        </li>
      </ul>
    );
  };
  const moduleList = () => {
    return (
      <div className="module-listitem">
        <div className="module-container align-center">
          <Skeleton className="module-image" height="130px" />
          <div className="module-content flex-width-auto">
            <Skeleton width={'70%'} />
            <Skeleton width={'100%'} />
            <Skeleton width={'50%'} />
            <Skeleton width={'70%'} />
          </div>
        </div>
        <div className="module-container align-center">
          <Skeleton className="module-image" height="130px" />
          <div className="module-content flex-width-auto">
            <Skeleton width={'70%'} />
            <Skeleton width={'100%'} />
            <Skeleton width={'50%'} />
            <Skeleton width={'70%'} />
          </div>
        </div>
        <div className="module-container align-center">
          <Skeleton className="module-image" height="130px" />
          <div className="module-content flex-width-auto">
            <Skeleton width={'70%'} />
            <Skeleton width={'100%'} />
            <Skeleton width={'50%'} />
            <Skeleton width={'70%'} />
          </div>
        </div>
      </div>
    );
  };
  const homeExamList = () => {
    return (
      <>
        <div className="exam-list">
          <Skeleton className="exam-date" />
          <div className="flex-column flex-justify-center ml-10 width-100">
            <Skeleton width={'70%'} />
            <Skeleton width={'50%'} />
          </div>
        </div>
        <div className="exam-list">
          <Skeleton className="exam-date" />
          <div className="flex-column flex-justify-center ml-10 width-100">
            <Skeleton width={'70%'} />
            <Skeleton width={'50%'} />
          </div>
        </div>
        <div className="exam-list">
          <Skeleton className="exam-date" />
          <div className="flex-column flex-justify-center ml-10 width-100">
            <Skeleton width={'70%'} />
            <Skeleton width={'50%'} />
          </div>
        </div>
      </>
    );
  };

  switch (props.type) {
    case 'card':
      return (
        <div>
          <Skeleton variant="text" />
          <Skeleton />
          <Skeleton />
        </div>
      );
    case 'image':
      return (
        <Skeleton
          variant="rect"
          width={props.width || '100%'}
          height={props.height || 10}
        />
      );
    case 'bigcard':
      return <div>{bigCard()}</div>;
    case 'bigcardlist':
      return (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            {bigCard()}
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            {bigCard()}
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            {bigCard()}
          </Grid>
          <Grid item xs={12} sm={6} md={3} lg={3}>
            {bigCard()}
          </Grid>
        </Grid>
      );
    case 'smallcard':
      return <>{smallCard()}</>;
    case 'downloads':
      return (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {downloads()}
        </Grid>
      )
    case 'smallcardlist':
      return (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            {smallCardList()}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            {smallCardList()}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            {smallCardList()}
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            {smallCardList()}
          </Grid>
        </Grid>
      );
    case 'homeBatchlist':
      return <>{homeBatchlist()}</>;
    case 'homeExamList':
      return <>{homeExamList()}</>;
    case 'moduleList':
      return <>{moduleList()}</>;
    default:
      return (
        <div>
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </div>
      );
    case 'listItem':
      return <> {listItem()} </>;
  }
}
LoadingSkeleton.propTypes = {
  type: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

// *** Availble types ***
// card
// image
// bigcard
// bigcardlist
// smallcard
// smallcardlist
// downloads
// homeBatchlist
// homeExamList
// moduleList
